export default __webpack_public_path__ + "static/media/9_16-clip-combined.3b8b8611.png";